import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import config from 'cityads-v3/config';
import { RootState } from 'cityads-v3/types/reducer';

import {
  toggleMenu,
} from 'cityads-v3/actions/menu';

import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import MenuContent from './MenuContent';

import classes from './Menu.scss';

export default function MenuMobile() {
  const dispatch = useDispatch()
  const opened = useSelector((state: RootState) => state.menu.opened)

  const handleToggle = useCallback((open: boolean) => () => {
    dispatch(toggleMenu(open))
  }, [dispatch])

  return (
    <SwipeableDrawer
      open={opened}
      onOpen={handleToggle(true)}
      onClose={handleToggle(false)}
      swipeAreaWidth={config.MOBILE_SWIPE_AREA_WIDTH}
      variant="temporary"
      classes={{
        paper: classes.menuContainer
      }}
    >
      <MenuContent />
    </SwipeableDrawer>
  )
}
